var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 15,
    viewBox: "0 0 42 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-26.6061 6.6028H-28V9.29438H-26.6061V6.6028ZM40.2993 7.94859L41.4418 8.71963L42 7.94859L41.4418 7.17755L40.2993 7.94859ZM-26.6061 9.29438H40.2993V6.6028H-26.6061V9.29438ZM41.4418 7.17755L36.2452 0L33.9604 1.54208L39.1569 8.71963L41.4418 7.17755ZM39.1569 7.17755L34.61 13.4579L36.8948 15L41.4418 8.71963L39.1569 7.17755Z",
    fill: "#2F57BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderRight);
export default __webpack_public_path__ + "static/media/sliderRight.4cebf7a13d4164a44186855badd3724c.svg";
export { ForwardRef as ReactComponent };